import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Survey, SubmitSurveyBody, SubmitSurveyResponse, SubmitAnswerDTO } from './SurveyTypes';
import { ErrorResponse } from 'store/ReduxTypes';
import { api } from '@utils/api';

/* ---------- GET /surveys/active ---------- */
export const getActiveSurveyOperation = createAsyncThunk<
  Survey,
  void,
  { rejectValue: ErrorResponse }
>('survey/getActive', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<Survey>('/surveys/active');
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ---------- POST /survey/instances ---------- */
export const submitSurveyOperation = createAsyncThunk<
  SubmitSurveyResponse,
  { surveyId: number; answers: SubmitAnswerDTO[] },
  { rejectValue: ErrorResponse }
>('survey/submit', async ({ surveyId, answers }, { rejectWithValue }) => {
  try {
    const body: SubmitSurveyBody = { survey_id: surveyId, answers };
    const { data } = await api.post<SubmitSurveyResponse>('/survey/instances', body);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ---------- POST /api/v1/regenerate-programs/rollover_for_user ---------- */
export const regenerateProgramOperation = createAsyncThunk<
  void,
  void,
  { rejectValue: ErrorResponse }
>('survey/regenerateProgram', async (_, { rejectWithValue }) => {
  try {
    await api.post('/regenerate-programs/rollover_for_user');
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ---------- POST /api/v1/regenerate-programs/rollover_for_user/full_with_order ---------- */
export const regenerateProgramWithOrderOperation = createAsyncThunk<
  void,
  void,
  { rejectValue: ErrorResponse }
>('survey/regenerateProgramWithOrder', async (_, { rejectWithValue }) => {
  try {
    await api.post('/regenerate-programs/full-with-order');
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
